import React from "react";

// ui importing
import FormTitle from "./formTitle";
import FormContent from "./formContent";

const Form = () => {

  return (
    <div className="
      flex flex-col md:w-[40rem] md:h-max
      w-full h-full
      bg-white
      shadow-md rounded-md
      border-2 border-slate-50
      text-white
    ">
      {/* title */}
      <FormTitle />

      {/* content */}
      <FormContent />
    </div>
  )
}

export default Form;
